import { IRootState } from '../../../store'
import { IFillablePDFsState } from '../store/fillablePDFs.types'

export const getFillablePDFsSelector = (state: IRootState): IFillablePDFsState => state.fillablePDFs
